import { Theme, useMediaQuery } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ItemCreation, ItemCreationSideSectionWrapper, ItemCreationWrapper } from '~/Components';
import { StudioCreationTour } from '~/Components/ProductTours/tours/StudioCreationTour';
import { GRAY_DARK_SHADE_1, WHITE } from '~/Constants/Colors.constants';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { ExtendedLocation } from './ExtendedLocation.model';
import { LocationEditSideSection } from './LocationEditSideSection';
import { useLocationEdit } from './useLocationEdit';

export const LocationEdit = () => {
  const { t } = useTranslation();

  const {
    listItems,
    headers,
    onSave,
    initialValues,
    validate,
    error,
    isLoading,
    currentLocation,
    validationSchema,
    onValidationErrors,
    showFormErrors,
  } = useLocationEdit();

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const backgroundColor = isMobile ? GRAY_DARK_SHADE_1 : WHITE;

  return (
    <PrivateLayout
      title={t('settings.locations')}
      actionDisabled={isLoading}
      actionName={t('app.save')}
      onActionTaken={onSave}
      backgroundColor={backgroundColor}
    >
      <StudioCreationTour />
      <ItemCreationWrapper showAll>
        <ItemCreation<ExtendedLocation>
          listItems={listItems}
          headers={headers}
          onSave={onSave}
          initialValues={initialValues}
          validate={validate}
          networkError={error}
          isLoading={isLoading}
          validationSchema={validationSchema}
          onValidationErrors={onValidationErrors}
          showFormErrors={showFormErrors}
        />
        <ItemCreationSideSectionWrapper>
          <LocationEditSideSection
            displayWeekdays={currentLocation.openingHours?.weekdays}
            openingHoursDescription={currentLocation.openingHours?.description}
            title={currentLocation.name}
            description={currentLocation.description}
            images={currentLocation.images}
            importantInfo={currentLocation.importantInformation}
            coordinates={{ lat: currentLocation.latitude, lng: currentLocation.longitude }}
            street={currentLocation.street}
            city={currentLocation.city}
            zipCode={currentLocation.zipCode}
            profileUrl={currentLocation.profileUrl}
          />
        </ItemCreationSideSectionWrapper>
      </ItemCreationWrapper>
    </PrivateLayout>
  );
};
